import { render, staticRenderFns } from "./retain_info.vue?vue&type=template&id=a7c4ba94&scoped=true"
import script from "./retain_info.vue?vue&type=script&lang=js"
export * from "./retain_info.vue?vue&type=script&lang=js"
import style0 from "./retain_info.vue?vue&type=style&index=0&id=a7c4ba94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c4ba94",
  null
  
)

export default component.exports